import styled from 'styled-components';
import { colors, mixins } from '../../../css';
import breakPoints from '../../../css/breakpoints';
import Text from '../../../BuildingBlocks/Text';

const { pxToRem } = mixins;

export const DrawerSelectContainer = styled.div`
  margin: 0 11px;
  border: 1px solid ${colors.colorGrey04};
  width: 100%-[11px];
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  @media (max-width: ${breakPoints.md}px) {
    padding: 10px ${pxToRem(20)};
  }

  position: relative;
  box-shadow: 0px 2px 5px 0px ${colors.colorBurgundyRgba(0.1)};

  .select-group {
    position: relative;
    z-index: 1;
    min-width: 160px;

    .select-label {
      margin-right: 5px;
    }

    > div {
      min-width: 100px;
    }

    svg {
      position: absolute;
      right: 0px;
      top: calc(50% - 10px);
      z-index: -1;
    }

    div {
      background: transparent;
    }
  }
`;

export const FormattedCopyMini = styled(Text.CopyMini)`
  font-size: ${mixins.pxToRem(12)};
`;

export const SelectValue = styled(Text.CopyMini)`
  color: ${colors.colorBlue03};
  font-size: ${mixins.pxToRem(12)};
  padding-left: 5px;
`;

export const GridListToggleButton = styled.div`
  color: ${colors.colorWhite};
  padding: 8px;
  padding-left: 30px;
  cursor: pointer;
  border-left: 2px solid ${colors.colorGrey04};
  margin-left: 30px;
  outline: none;

  figure {
    display: block;
  }
`;
